export const UtilsActionTypes = {
    LOADING_TOP_ON: 'LOADING_TOP_ON',
    FULL_PAGE_LOAD: 'FULL_PAGE_LOAD',
    CURRENT_PROD: 'CURRENT_PROD',
    MODAL_PROD: 'MODAL_PROD',
    MODAL_MENU: 'MODAL_MENU',
    CURRENT_PAGE: 'CURRENT_PAGE'
}